import { css, cx } from "@emotion/css";
import { memo, ReactNode, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

export type FullScreenNotificationLayoutProps = {
  children?: ReactNode;
  variant: "success" | "failed";
  onSubmit: () => void;
};

const TIMEOUT_DURATION = 3_000;

export const FullScreenNotificationLayout = memo(
  ({ children, variant, onSubmit }: FullScreenNotificationLayoutProps) => {
    const classes = createStyles(useTheme());
    const history = useHistory();

    useEffect(() => {
      const timeout = setTimeout(() => {
        onSubmit();
      }, TIMEOUT_DURATION);

      return () => {
        clearTimeout(timeout);
      };
    }, [history, onSubmit]);

    return (
      <div className={classes.root} onClick={onSubmit} role="button">
        <main className={cx(classes.content, classes[variant])}>
          {children}
        </main>
      </div>
    );
  }
);

function createStyles({ palette }: Theme) {
  return {
    root: css({
      width: "100%",
      height: "100%",
    }),
    content: css({
      display: "grid",
      placeItems: "center",
      position: "relative",
      width: "100%",
      height: "100%",
    }),
    success: css({
      backgroundImage: palette.gradient.testSuccess,
    }),
    failed: css({
      backgroundImage: palette.gradient.testFailed,
    }),
  };
}
